import { useState, useEffect, useCallback } from 'react';
import Cookies from 'universal-cookie';

type Language = 'ru' | 'en' | 'md' | string;

const cookies = new Cookies();
const LANGUAGE_KEY = 'language';
const DEFAULT_LANGUAGE = 'ru';

export const useLanguage = () => {
  const [language, setLanguageState] = useState<Language>(() => {
    return cookies.get(LANGUAGE_KEY) || DEFAULT_LANGUAGE;
  });

  const setLanguage = useCallback((lang: Language) => {
    cookies.set(LANGUAGE_KEY, lang, {
      path: '/',
      sameSite: 'lax',
      secure: window.location.protocol === 'https:',
      maxAge: 31536000,
    });
    setLanguageState(lang);
  }, []);

  useEffect(() => {
    const currentLang = cookies.get(LANGUAGE_KEY);
    if (!currentLang) {
      cookies.set(LANGUAGE_KEY, DEFAULT_LANGUAGE, {
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
        maxAge: 31536000,
      });
    }
  }, []);

  return { lang: language, setLanguage };
};

export default useLanguage;
